export const START_DATE = 'startDate';
export const END_DATE = 'endDate';
export const START_TIME = 'startTime';
export const END_TIME = 'endTime';
export const MONTHS = 'months';
export const MONTH = 'month';
export const DAYS = 'days';
export const DAY = 'day';
